export const TID = {
  // Nav
  navContainer: "main-navbar",
  navLogo: "nav-logo",
  navLinkHome: "nav-link-home",
  navLinkServices: "nav-link-services",
  navLinkWhy: "nav-link-why",
  navLinkTestimonials: "nav-link-testimonials",
  navLinkFAQ: "nav-link-faq",
  navLinkContact: "nav-link-contact",
  navBookCta: "nav-book-consultation-btn",
  navThemeToggle: "nav-theme-toggle",
  navMobileToggle: "nav-mobile-toggle",
  navMobilePanel: "nav-mobile-panel",

  // Hero
  heroSection: "hero-section",
  heroPrimaryCta: "hero-primary-cta-book-consultation",
  heroSecondaryCta: "hero-secondary-cta-whatsapp",

  // Stats
  statsSection: "stats-section",
  statItem: (key) => `stat-item-${key}`,

  // Services
  servicesSection: "services-section",
  serviceCard: (key) => `service-card-${key}`,
  servicesAuditCta: "services-request-audit-btn",
  servicesGrowCta: "services-grow-business-btn",

  // Why us
  whyUsSection: "why-us-section",
  whyUsCard: (key) => `why-us-card-${key}`,

  // Process
  processSection: "process-section",
  processStep: (n) => `process-step-${n}`,

  // Testimonials
  testimonialsSection: "testimonials-section",
  testimonialCard: (n) => `testimonial-card-${n}`,
  testimonialPrev: "testimonial-prev-btn",
  testimonialNext: "testimonial-next-btn",

  // FAQ
  faqSection: "faq-section",
  faqItem: (n) => `faq-item-${n}`,

  // Contact
  contactSection: "contact-section",
  contactName: "contact-input-name",
  contactCompany: "contact-input-company",
  contactEmail: "contact-input-email",
  contactPhone: "contact-input-phone",
  contactService: "contact-select-service",
  contactBudget: "contact-select-budget",
  contactMessage: "contact-textarea-message",
  contactHoneypot: "contact-honeypot-website",
  contactSubmit: "contact-submit-btn",
  contactSuccess: "contact-success-message",
  contactWhatsAppCta: "contact-whatsapp-cta",

  // Footer
  footer: "site-footer",
  footerPrivacy: "footer-privacy-link",
  footerTerms: "footer-terms-link",

  // Floaters
  floatWhatsApp: "floating-whatsapp-btn",
  floatBackToTop: "floating-back-to-top-btn",
  scrollProgress: "scroll-progress-bar",
  cookieBanner: "cookie-consent-banner",
  cookieAccept: "cookie-accept-btn",
  cookieDecline: "cookie-decline-btn",
};

export default TID;
